import * as React from 'react'

import { PostNavigationBanner } from '../../../Shared'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/pages/dashboard/bulk_archive_close_icon_orange.svg`

const SchoolYearUpdatesCard = ({ handleCloseCard, }) => {
  return (
    <PostNavigationBanner
      bannerStyle="gold-secondary school-year-updates-card"
      bodyText={
        <ul>
          <li>We just launched Diagnostic Insights, a new report that shows the completed diagnostics for each of your students from previous school years and recommends which diagnostic they should work on next.</li>
          <li>It’s free for all teachers, but you must be verified by your admin to view your students’ data from previous years.</li>
          <li>The report highlights proficiency levels from prior years so you can build on students’ prior learning and progress.</li>
          <li>This is the first time Quill has provided historical data to teachers, and we’d love your feedback on how we can best show you your students’ prior progress on Quill.</li>
        </ul>
      }
      buttons={[
        {
          className: 'gold small contained focus-on-light',
          href: '/teachers/progress_reports/diagnostic_insights',
          text: "Learn more about Diagnostic Insights",
          target: "_blank"
        }
      ]}
      closeAria="Hide card until next school year"
      closeIconSrc={closeIconSrc}
      handleCloseCard={handleCloseCard}
      icon={{ alt: "Image of a school building", src: "https://assets.quill.org/images/banners/large-school-campus-gold.svg" }}
      primaryHeaderText="🎉 Announcing Diagnostic Insights — Free for Verified Teachers"
    />
  )
}

export default SchoolYearUpdatesCard
